import React from "react";
import { FaCheckDouble } from "react-icons/fa";
import Loader from "../../components/Loader/Loader";
import CardHeader from "../../components/Card/CardHeader";
import ParentRequestCard from "./ParentRequestCard";
import ParentRequestFilter from "./ParentRequestFilter";
import { useParentRequests } from "./useParentRequests";

const ParentRequestApproval = () => {
  const {
    visibleItems,
    isLoader,
    selectedFields,
    status,
    id_number,
    setStatus,
    setIdNumber,
    fetchParentRequests,
    toggleField,
    handleRequest,
  } = useParentRequests();

  return isLoader ? (
    <Loader />
  ) : (
    <div className="card p-4">

      <CardHeader
        title="Parent Edit Requests"
        icon={<FaCheckDouble />}
        button={null}
      />

      {/* Filters */}
      <ParentRequestFilter
        fetchParentRequests={fetchParentRequests}
        status={status}
        setStatus={setStatus}
        id_number={id_number}
        setIdNumber={setIdNumber}
      />

      {/* List */}
      <div className="mt-3">
        {visibleItems.length === 0 ? (
          <p className="text-center text-muted py-4">
            No parent edit requests found.
          </p>
        ) : (
          visibleItems.map((item, index) => (
            <ParentRequestCard
              key={item.id}
              item={item}
              selectedFields={selectedFields[item.id] || []}
              toggleField={toggleField}
              onApprove={(comment) =>
                handleRequest(item.id, "approved", comment)
              }
              onReject={(comment) =>
                handleRequest(item.id, "rejected", comment)
              }
              defaultExpanded={index === 0}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(ParentRequestApproval);
